
import { Card } from "@/components/ui/card";

interface StatCardProps {
  title: string;
  value: string;
  icon: React.ReactNode;
  trend: string;
}

export const StatCard = ({ title, value, icon, trend }: StatCardProps) => (
  <Card className="p-6 bg-zinc-800/20 border-zinc-700">
    <div className="flex items-center justify-between mb-4">
      <h3 className="text-white flex items-center gap-2">
        {icon}
        {title}
      </h3>
      <span className="text-green-400 text-sm">{trend}</span>
    </div>
    <div className="text-3xl font-bold text-white">
      {parseInt(value).toLocaleString()}
    </div>
  </Card>
);
